module.exports = __webpack_public_path__ + "img/fdc.4db46ef5.png";